import mergeMd from 'react-codemirror-merge/README.md';

export const mdSource = {
  document: mergeMd.source,
};
